import { css } from 'lit';

export default css`
    :host {
        --pointer-size: var(--metrics-spacing-s);
        --label-offset: var(--metrics-spacing-xs);
        --label-bottom: var(--metrics-spacing-xs);
    }

    .alarm-bar-container {
        position: relative;
    }

    .alarm-bar {
        display: flex;
        list-style: none;
        padding-inline-start: 0;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
    }

    .alarm-bar > li {
        display: flex;
        position: relative;
        justify-content: end;
        font-size: var(--font-size-body-xs);
        flex: 1;
        padding: var(--metrics-spacing-s) 0;
    }

    .alarm-bar > li > .label-left {
        position: absolute;
        left: calc(-1 * var(--label-offset));
        bottom: var(--label-bottom);
    }

    .alarm-bar > li > .label-right {
        position: absolute;
        right: calc(-1 * var(--label-offset));
        bottom: var(--label-bottom);
    }

    .alarm-pointer {
        position: absolute;
        bottom: calc(-1 * var(--pointer-size) * 2);
        width: 0;
        height: 0;
        margin-left: calc(-1 * var(--pointer-size));
        border-left: var(--pointer-size) solid transparent;
        border-right: var(--pointer-size) solid transparent;
        border-bottom: var(--pointer-size) solid var(--color-surface-contrast);
    }

    .alarm-pointer.rotated-right {
        transform: rotate(90deg);
    }

    .alarm-pointer.rotated-left {
        transform: rotate(-90deg);
    }
`;
